import { parse, setWeek, setYear, compareAsc, compareDesc } from "date-fns";

// Helper function to map month names to numbers
const monthNameToNumber = (monthName) => {
  const monthNames = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };
  return monthNames[monthName] || "01"; // Default to January if month name is invalid
};

// Helper function to get the year for two-digit years
const getFullYearFromTwoDigit = (yearStr) => {
  return parseInt(yearStr, 10) < 50
    ? 2000 + parseInt(yearStr, 10)
    : 1900 + parseInt(yearStr, 10);
};

// Helper function to adjust for fiscal year sorting
const adjustForFiscalYear = (date, fiscalYearStartMonth) => {
  const month = date.getMonth() + 1; // getMonth() returns 0-indexed month
  const year = date.getFullYear();

  if (month < fiscalYearStartMonth) {
    return new Date(year + 1, month - 1, 1); // Adjust to the previous fiscal year
  } else {
    return new Date(year, month - 1, 1); // Stay in the current fiscal year
  }
};

const parseDate = (dateStr, format, fiscalYearStartMonth) => {
  console.log(dateStr);
  console.log(format);

  let parsedDate;
  if (dateStr && format) {
    switch (format) {
      case "%M": // Example: January, February, March...
        const currentYear1 = new Date().getFullYear();
        const monthNumber = monthNameToNumber(dateStr); // Convert month name to number (1-12)

        if (isNaN(monthNumber)) {
          console.error("Invalid month name:", dateStr);
          return null;
        }

        parsedDate = new Date(currentYear1, monthNumber - 1, 1); // Set to first day of the month
        parsedDate = adjustForFiscalYear(parsedDate, fiscalYearStartMonth); // Adjust for fiscal year
        break;

      case "%b": // Example: Sep
        const currentYear2 = new Date().getFullYear();
        parsedDate = parse(dateStr, "MMM", new Date());
        parsedDate = new Date(currentYear2, parsedDate.getMonth(), 1); // Set to the first day of the month
        parsedDate = adjustForFiscalYear(parsedDate, fiscalYearStartMonth);
        break;

      case "%b-%y": // Example: Sep-24
        parsedDate = parse(dateStr, "MMM-yy", new Date());
        break;

      case "%M-%y": // Example: September-24
        parsedDate = parse(dateStr, "MMMM-yy", new Date());
        break;

        case "%Q-%Y": // Example: Q1 2024 or Q1 FY 2024
        const cleanedDateStr1 = dateStr.trim(); // Remove leading and trailing spaces
        const [quarterStr, yearStrQ] = cleanedDateStr1
          .replace("FY ", "")
          .split(" "); // Remove "FY " and split

        if (!quarterStr || !yearStrQ) {
          console.error("Invalid date format:", dateStr);
          return null;
        }

        const quarterNum1 = parseInt(quarterStr.replace("Q", ""), 10); // Extract quarter number
        const year = parseInt(yearStrQ, 10); // Extract year

        console.log(quarterNum1);
        console.log(new Date(year, 0, 1));

        if (isNaN(quarterNum1) || isNaN(year)) {
          console.error("Invalid quarter or year:", dateStr);
          return null;
        }

        parsedDate = new Date(year, (quarterNum1 - 1) * 3, 1); // Set to first month of quarter
        break;

      // case "%Q-%Y": // Example: Q1-2024
      //   const [quarter1, year1] = dateStr.split("-");
      //   parsedDate = new Date(
      //     year1,
      //     (parseInt(quarter1.replace("Q", ""), 10) - 1) * 3,
      //     1
      //   );
      //   break;

      case "%Q-%y": // Example: Q1-24, Q4 FY 14, Q4 14
        const cleanedDateStr = dateStr.replace("FY ", "").trim(); // Remove "FY " if present
        const [quarter2, year2] = cleanedDateStr.split(" "); // Split by space

        if (!quarter2 || !year2) {
          console.error("Invalid date format:", dateStr);
          return null;
        }

        const fullYear = getFullYearFromTwoDigit(year2); // Convert 2-digit year to full year
        const quarterNum = parseInt(quarter2.replace("Q", ""), 10); // Extract quarter number

        if (isNaN(quarterNum) || isNaN(fullYear)) {
          console.error("Invalid quarter or year:", dateStr);
          return null;
        }

        parsedDate = new Date(fullYear, (quarterNum - 1) * 3, 1); // Set to first month of quarter
        break;

      case "%Y-%W": // Example: 2024-W1
        const [weekYear, week] = dateStr.split("-W");
        parsedDate = setWeek(
          setYear(new Date(), parseInt(weekYear, 10)),
          parseInt(week, 10)
        );
        break;

      case "%W-%Y": // Example: W1-2024
        const [week1, weekYear1] = dateStr.split("-");
        parsedDate = setWeek(
          setYear(new Date(), parseInt(weekYear1, 10)),
          parseInt(week1.replace("W", ""), 10)
        );
        break;

      case "%W-%y": // Example: W1-24
        const [week2, weekYear2] = dateStr.split("-");
        const fullWeekYear = getFullYearFromTwoDigit(weekYear2);
        parsedDate = setWeek(
          setYear(new Date(), fullWeekYear),
          parseInt(week2.replace("W", ""), 10)
        );
        break;

      case "Wx": // Example: WK -1, WK -2 (relative to current week)
        const match = dateStr.match(/WK\s*-\s*(\d+)/); // Extract the week offset (e.g., -1, -2)

        if (!match) {
          console.error("Invalid week format:", dateStr);
          return null;
        }

        const weekOffset = parseInt(match[1], 10); // Convert extracted number to an integer
        console.log(weekOffset);
        parsedDate = weekOffset;
        break;

      case "%Y": // Example: 2024 or FY 2024
        let yearStr = dateStr.replace(/FY\s*/, "").trim(); // Remove "FY " if present
        parsedDate = new Date(parseInt(yearStr, 10), 0, 1); // Set to January 1st of the given year
        break;

      case "%y": // Example: "24" or "FY 24"
        let shortYearStr = dateStr.replace(/FY\s*/, "").trim(); // Remove "FY " if present
        const fullYearValue = getFullYearFromTwoDigit(shortYearStr); // Convert to full year
        parsedDate = new Date(fullYearValue, 0, 1); // Set to January 1st of that year
        break;

      case "Qx": // Example: Q1, Q2, Q3, Q4 (Assume current year)
        const quarterOnly = dateStr.replace("Q", "").trim(); // Extract the quarter number

        if (isNaN(quarterOnly)) {
          console.error("Invalid quarter format:", dateStr);
          return null;
        }

        const currentYear = new Date().getFullYear();
        parsedDate = new Date(
          currentYear,
          (parseInt(quarterOnly, 10) - 1) * 3,
          1
        ); // Set to first month of quarter
        break;

      case "%Y-%m-%d": // Example: 2024-09-01
        parsedDate = parse(dateStr, "yyyy-MM-dd", new Date());
        break;

      case "%A": // Example: Monday
        parsedDate = parse(dateStr, "EEEE", new Date());
        break;

      case "%a": // Example: mon
        parsedDate = parse(dateStr, "EEE", new Date());
        break;

      case "%m-%d-%Y": // Example: 09-01-2024
        parsedDate = parse(dateStr, "MM-dd-yyyy", new Date());
        break;

      case "%M %d, %Y": // Example: September 01, 2024
        parsedDate = parse(dateStr, "MMMM dd, yyyy", new Date());
        break;

      case "%d.%m.%Y": // Example: 01.09.2024
        parsedDate = parse(dateStr, "dd.MM.yyyy", new Date());
        break;

      default:
        console.error("Unsupported format code:", format);
        return new Date(dateStr); // Fallback to default parsing
    }
    console.log(parsedDate);

    return parsedDate;
  }
};

const dateSort = (
  data,
  key,
  format,
  order,
  customOrder,
  fiscalYearStartMonth = 1
) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    console.error("Invalid data provided");
    return [];
  }
  console.log(key);
  console.log(format);
  console.log(order);

  const sortedData = data.slice().sort((a, b) => {
    let modifiedAKey = a[key];
    console.log(modifiedAKey);
    let modifiedBKey = b[key];
    // console.log(modifiedBKey);
    const dateA = parseDate(modifiedAKey, format, fiscalYearStartMonth);
    console.log(dateA);
    const dateB = parseDate(modifiedBKey, format, fiscalYearStartMonth);
    console.log(dateB);
    if (order) {
      if (format === "Wx") {
        console.log(dateA);
        console.log(dateB);
        if (order === "ASC") {
          return dateA - dateB; // Smallest to Largest (WK -0 → WK -52)
        } else if (order === "DESC") {
          return dateB - dateA;
        }
      }
      if (order === "ASC") {
        // console.log(compareAsc(dateA, dateB));
        return compareAsc(dateA, dateB);
      } else if (order === "DESC") {
        // console.log(compareDesc(dateA, dateB));
        return compareDesc(dateA, dateB);
      } else if (order === "CUSTOM" && Array.isArray(customOrder)) {
        // Find the index of each date in the customOrder array
        const aIndex = customOrder.indexOf(a[key]);
        const bIndex = customOrder.indexOf(b[key]);

        // Handle cases where the dates are not found in the customOrder array
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1; // Place a[key] at the end if not in customOrder
        if (bIndex === -1) return -1; // Place b[key] at the end if not in customOrder

        return aIndex - bIndex; // Sort based on the customOrder indices
      }
    } else {
      console.error("order is not defined");
      console.log(compareAsc(dateA, dateB));

      return compareAsc(dateA, dateB);
    }
  });

  console.log(sortedData);

  return sortedData;
};

export { dateSort, parseDate };
